import { z } from 'zod';

export const SeedingRejectionReasonSchema = z
  .object({
    code: z.string(),
    label: z.string(),
  })
  .describe('SeedingRejectionReason');

export type SeedingRejectionReason = z.infer<typeof SeedingRejectionReasonSchema>;

export const GetSeedingRejectionReasonsServiceResponseSchema = z
  .object({
    reasons: z.array(SeedingRejectionReasonSchema),
  })
  .describe('GetSeedingRejectionReasonsServiceResponse');

export type GetSeedingRejectionReasonsServiceResponse = z.infer<
  typeof GetSeedingRejectionReasonsServiceResponseSchema
>;
